import { render, staticRenderFns } from "./RightMenuMailFolder.vue?vue&type=template&id=1c9eb8ca"
import script from "./RightMenuMailFolder.vue?vue&type=script&lang=js"
export * from "./RightMenuMailFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports